"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortHeader = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Icon_1 = require("../../Icon");
const TableState_1 = require("../utils/TableState");
const Css_1 = require("../../../Css");
const hooks_1 = require("../../../hooks");
const useTestIds_1 = require("../../../utils/useTestIds");
/**
 * Wraps column header names with up/down sorting icons.
 *
 * GridTable will use this automatically if the header content is just a text string.
 *
 * Alternatively, callers can also:
 *
 * - Instantiate this SortHeader directly with some customizations in `xss`, or
 * - Write their own component that uses `GridSortContext` to access the column's
 *   current sort state + `toggleSort` function
 */
function SortHeader(props) {
    const { content, xss, iconOnLeft = false, sortKey } = props;
    const { isHovered, hoverProps } = (0, hooks_1.useHover)({});
    const { tableState } = (0, react_1.useContext)(TableState_1.TableStateContext);
    const current = (0, hooks_1.useComputed)(() => { var _a; return (_a = tableState.sortState) === null || _a === void 0 ? void 0 : _a.current; }, [tableState]);
    const sorted = sortKey === (current === null || current === void 0 ? void 0 : current.columnId) ? current === null || current === void 0 ? void 0 : current.direction : undefined;
    const toggleSort = (0, react_1.useCallback)(() => tableState.setSortKey(sortKey), [sortKey, tableState]);
    const tid = (0, useTestIds_1.useTestIds)(props, "sortHeader");
    const icon = ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.fs0.$, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: sorted === "DESC" ? "sortDown" : "sortUp", color: sorted !== undefined ? Css_1.Palette.LightBlue700 : Css_1.Palette.Gray400, xss: {
                ...Css_1.Css.ml1.if(iconOnLeft).mr1.ml0.$,
                ...Css_1.Css.visibility("hidden")
                    .if(isHovered || sorted !== undefined)
                    .visibility("visible").$,
            }, inc: 2, ...tid.icon }) }));
    return ((0, jsx_runtime_1.jsxs)("div", { ...tid, css: { ...Css_1.Css.df.aic.h100.cursorPointer.selectNone.$, ...xss }, ...hoverProps, onClick: toggleSort, children: [iconOnLeft && icon, (0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.lineClamp2.$, children: content }), !iconOnLeft && icon] }));
}
exports.SortHeader = SortHeader;
